import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Layout = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname.startsWith(path);
  // Wide tables get more of the screen; forms and lists stay at reading width.
  const container = `container${isActive('/results') ? ' container-wide' : ''}`;

  return (
    <div>
      <header className="header">
        <div className={`${container} header-content`}>
          <Link to="/dashboard" className="logo">
            <img src="/lp-mark.png" alt="" className="logo-mark" />
            <span>LP Learning &amp; Assessment Portal</span>
          </Link>
          <nav className="nav-links">
            <Link
              to="/dashboard"
              className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
            >
              Dashboard
            </Link>
            <Link
              to="/quizzes"
              className={`nav-link ${isActive('/quizzes') ? 'active' : ''}`}
            >
              Quizzes
            </Link>
            <Link
              to="/sessions"
              className={`nav-link ${isActive('/sessions') ? 'active' : ''}`}
            >
              Sessions
            </Link>
            <Link
              to="/results"
              className={`nav-link ${isActive('/results') ? 'active' : ''}`}
            >
              Results
            </Link>
            <Link
              to="/attendance"
              className={`nav-link ${isActive('/attendance') ? 'active' : ''}`}
            >
              Attendance
            </Link>
            <Link
              to="/feedback"
              className={`nav-link ${isActive('/feedback') ? 'active' : ''}`}
            >
              Feedback
            </Link>
            <Link
              to="/certificates"
              className={`nav-link ${isActive('/certificates') ? 'active' : ''}`}
            >
              Certificates
            </Link>
            {user?.role === 'admin' && (
              <Link
                to="/categories"
                className={`nav-link ${isActive('/categories') ? 'active' : ''}`}
              >
                Categories
              </Link>
            )}
            {user?.role === 'admin' && (
              <Link
                to="/users"
                className={`nav-link ${isActive('/users') ? 'active' : ''}`}
              >
                Users
              </Link>
            )}
            <span className="text-muted">|</span>
            <span className="text-sm">
              {user?.name} ({user?.role})
            </span>
            <button onClick={logout} className="btn btn-secondary btn-sm">
              Logout
            </button>
          </nav>
        </div>
      </header>
      <main className={container} style={{ padding: '24px 20px' }}>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
